import React from 'react'

import { Card } from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/Card'
import * as styles from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/Cards.styles'
import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { FlowChartCardsBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartCardsBlock'

const BUTTON_HEIGHT_WITH_TOP_MARGIN = 72

export const CardsGenericBlock: BlockComponent<FlowChartCardsBlock> = (props) => {
  let gapsCount = 0

  return (
    <ContentContainer style={styles.List}>
      {props.block.data.cards.map((card, index) => {
        const marginBottom = gapsCount * BUTTON_HEIGHT_WITH_TOP_MARGIN

        gapsCount += card.buttons.length

        return (
          <view
            key={card.id}
            style={{
              ...styles.CardWrapper,
              marginBottom,
            }}
          >
            <Card card={card} withShadow={index > 0} />
          </view>
        )
      })}
    </ContentContainer>
  )
}
